<template>
  <Loader :loading="loading" ref="slotSelector" class="slot-container">
    <div class="info" v-if="
      scheduleInfo &&
      scheduleInfo.length > 0 &&
      availableSlots.length &&
      slotsToShow
    ">
      {{ scheduleInfo }}
    </div>
    <h4 v-if="slotTitleKey">{{ t.getOrKey(slotTitleKey) }}</h4>
    <span :class="[
      'slot',
      'slot-state-' + slot.state,
      'loader-xs',
      !!selectedSlot && !!selectedSlot.idData && !!selectedSlot.idData.length && slot.idData === selectedSlot.idData
        ? 'slot-selected'
        : '',
    ]" v-for="slot in availableSlots" :key="slot.id" @click="selectSlot(slot)">
      {{ slotsToShow ? formatDate(slot.start) + " klo " : "" }}

      {{ formatTime(slot.start) }}
      <div v-if="slot.state === slotStates.selecting" class="loader"></div>
      <font-awesome-icon v-if="slot.state === slotStates.error"
        :icon="['fas', 'exclamation-triangle']"></font-awesome-icon>
    </span>

    <div v-if="!availableSlots.length && initialSlotsFetched && !loading">
      {{ t.getOrKey("Label.NoSlotsAvailable") }}
    </div>
  </Loader>
</template>
<script>
import util from "@/services/utils";
import Loader from "./Loader";
import api from "@/services/api-service";
import t from "@/services/translation-service";

export const slotStates = {
  error: "error",
  selecting: "selecting",
  selected: "selected",
  disabled: "disabled",
  unselected: "unselected",
};

export default {
  components: {
    Loader,
  },
  props: {
    selectedServiceIds: Array,
    selectedProviderId: String,
    selectedDate: Date,
    reservationId: String,
    scheduleInfo: String,
    slotsToShow: Array,
    slotTitleKey: String,
    selectedSlot: Object,
    onBeforeSelect: {
      type: Function,
      required: false
    }
  },
  watch: {
    selectedDate() {
      this.getSlots();
    },
    slotsToShow() {
      this.mapSlotsToShow();
      this.loading = false;
    },
    selectedSlot() {
    }
  },
  methods: {
    mapSlotsToShow() {
      this.availableSlots = this.slotsToShow.map((s) => {
        return {
          id: s.id,
          end: new Date(s.end),
          start: new Date(s.start),
          state: slotStates.unselected,
          idData: s.idData
        };
      });
    },
    clearData() {
      this.availableSlots = [];
      this.currentlySelected = undefined;
      this.$emit("change", undefined);
    },
    formatDate: util.formatDate,
    formatTime: util.formatTime,
    //formatToApiDate: util.formatToApiDate,
    scrollToSlots() {
      this.$refs["slotSelector"].$el.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    setCurrentSlot(cur) {
      this.availableSlots = [...this.availableSlots.map(s => ({ ...s, state: slotStates.unselected }))]
      if (this.currentlySelected) {
        this.currentlySelected.state = slotStates.unselected;
      }
      this.currentlySelected = cur;
    },
    selectSlot(slot) {
      if (
        this.reservingSlot ||
        slot.state === slotStates.disabled ||
        slot.id === this.currentlySelected?.id
      ) {
        return;
      }
      if (this.onBeforeSelect && !this.onBeforeSelect()) {
        return;
      }

      this.reservingSlot = true;
      slot.state = slotStates.selecting;
      api
        .reserverSlot(slot.id, this.reservationId)
        .then((response) => {
          if (this.currentlySelected) {
            this.currentlySelected.state = slotStates.unselected;
          }
          this.currentlySelected = slot;
          this.currentlySelected.state = slotStates.selected;
          const resId = util.isBlank(response.data.reservationId)
            ? this.reservationId
            : response.data.reservationId;
          this.$emit("change", {
            ...this.currentlySelected,
            reservationId: resId
          });
        })
        .catch((error) => {
          if (error?.response?.data?.code) {
            if (error.response.data.code === "SlotTaken") {
              slot.state = slotStates.disabled;
            } else {
              slot.state = slotStates.error;
            }
          } else {
            slot.state = slotStates.error;
          }
        })
        .finally(() => {
          this.reservingSlot = false;
        });
    },
    getSlots() {
      if (this.selectedDate === undefined) {
        this.mapSlotsToShow();
        this.loading = false;
        return;
      }
      this.loading = true;
      api
        .getSlots(
          this.selectedServiceIds,
          this.selectedProviderId,
          this.selectedDate
        )
        .then((data) => {
          this.availableSlots = data.map((s) => {
            return {
              id: s.id,
              end: new Date(s.end),
              start: new Date(s.start),
              state: slotStates.unselected,
            };
          });
          const vm = this;
          setTimeout(vm.scrollToSlots, 100);
        })
        .finally(() => {
          this.loading = false;
          this.initialSlotsFetched = true;
        });
    },
  },
  data() {
    return {
      loading: true,
      initialSlotsFetched: false,
      availableSlots: [],
      currentlySelected: undefined,
      reservingSlot: false,
      t: t,
      slotStates: slotStates,
    };
  },
  created() {
    this.getSlots();
  },
};
</script>
<style scoped>
.slot {
  flex: 1 1 225px;
  border: 1px solid lightgray;
  border-radius: 0.5rem;
  max-width: 225px;
  text-align: center;
  padding: 0.5rem;
  margin: 0 0.5rem 0.5rem 0;
  cursor: pointer;
}

.slot-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
  margin-left: 1rem;
}

@media screen and (max-width: 767px) {
  .slot-container {
    justify-content: center;
  }

  .slot {
    flex: 1 1 calc(50% - 0.5rem);
  }
}

.slot-state-selecting {
  background-color: #ff8241;
  color: white;
}

.slot-selected, .slot-state-selected {
  background-color: #28a745;
  color: white;
  pointer-events: none;
}

.slot-state-error {
  background-color: #dc3545;
  color: white;
  cursor: not-allowed;
}

.slot-state-disabled {
  color: lightgray;
  cursor: not-allowed;
}

.loader-xs .loader:after,
.loader-xs .loader {
  background-color: #ff8241;
}
</style>
